import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    const wrapper = document.querySelector('.app-wrapper');
    if (wrapper) wrapper.scrollTop = 0;

    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: 'Page404',
      components: {
        default: () => import('./views/Page404'),
        auth: () => import('./views/Page404'),
      },
    },
    {
      path: '/',
      name: 'Dashboard',
      components: {
        default: () => import('./views/Dashboard'),
        auth: () => import('./views/Auth/index'),
      },
    },
    {
      path: '/forgot',
      name: 'Forgot',
      components: {
        auth: () => import('./views/Auth/Forgot'),
      },
    },
    {
      path: '/live',
      redirect: '/live/1',
      meta: {
        auth: true,
      },
    },
    {
      path: '/ticker',
      name: 'Ticker',
      component: () => import('./views/Ticker'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/live/:page',
      name: 'Live',
      component: () => import('./views/Live'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/data',
      name: 'Data',
      component: () => import('./views/Data'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/users',
      redirect: '/users/1',
      meta: {
        auth: true,
      },
    },
    {
      path: '/users/:page',
      name: 'Users',
      component: () => import('./views/Users'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/subscription',
      name: 'Subscription',
      component: () => import('./views/Subscription'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/profiles',
      name: 'Profiles',
      component: () => import('./views/Profiles'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/social',
      name: 'Social',
      component: () => import('./views/Social'),
      meta: {
        auth: true,
      },
    },
    // {
    //   path: "/dadbee",
    //   name: "DadBee",
    //   component: () => import("./views/Dadbee"),
    //   meta: {
    //     auth: true
    //   }
    // },
    {
      path: '/prematch',
      name: 'Prematch',
      component: () => import('./views/Prematch'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('./views/Settings'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/ads',
      name: 'Ads',
      component: () => import('./views/Ads'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/admin',
      name: 'Admins',
      component: () => import('./views/Admins'),
      meta: {
        auth: true,
      },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeResolve((to, from, next) => {
  if (to.meta && to.meta.auth === true) {
    if (!store.getters.isAuth) next('/');
  }
  next();
});

export default router;
